// Icons referenced by name from server data (rooms, badges, stickers).
// Listed explicitly so the bundle only carries the icons we use.
import {
  Bath, BedDouble, Bird, BookOpenCheck, Bot, CalendarCheck, Castle, Cat, Citrus, CookingPot, Coffee, Droplets, Flame, Flower2,
  Gem, Handshake, House, Lamp, LayoutGrid, Leaf, LifeBuoy, Medal, Moon, MoonStar, PaintBucket, Rainbow, Rocket, Shirt,
  SoapDispenserDroplet, Sofa, Sparkles, SprayCan, Sprout, Star, Sticker, Sunrise, Trees, Trophy, WandSparkles, WashingMachine,
  Snowflake, Crown, Fish, BadgeCheck, Zap, Building2, Footprints, Monitor, Utensils, Car, BedSingle, Dog, Rabbit, GlassWater,
  Wind, Toilet, DoorOpen, PawPrint, Timer, type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  bath: Bath, 'bed-double': BedDouble, bird: Bird, 'book-open-check': BookOpenCheck, bot: Bot, 'calendar-check': CalendarCheck,
  castle: Castle, cat: Cat, citrus: Citrus, 'cooking-pot': CookingPot, coffee: Coffee, droplets: Droplets, flame: Flame,
  'flower-2': Flower2, gem: Gem, handshake: Handshake, house: House, lamp: Lamp, 'layout-grid': LayoutGrid, leaf: Leaf,
  'life-buoy': LifeBuoy, medal: Medal, moon: Moon, 'moon-star': MoonStar, 'paint-bucket': PaintBucket, rainbow: Rainbow,
  rocket: Rocket, shirt: Shirt, 'soap-dispenser-droplet': SoapDispenserDroplet, sofa: Sofa, sparkles: Sparkles,
  'spray-can': SprayCan, sprout: Sprout, star: Star, sticker: Sticker, sunrise: Sunrise, trees: Trees, trophy: Trophy,
  'wand-sparkles': WandSparkles, 'washing-machine': WashingMachine, snowflake: Snowflake, crown: Crown, fish: Fish,
  'badge-check': BadgeCheck, zap: Zap, 'building-2': Building2, footprints: Footprints, monitor: Monitor, utensils: Utensils,
  car: Car, 'bed-single': BedSingle, dog: Dog, rabbit: Rabbit, 'glass-water': GlassWater, wind: Wind, toilet: Toilet,
  'door-open': DoorOpen, 'paw-print': PawPrint, timer: Timer,
};

export function NamedIcon({ name, className }: { name: string; className?: string }) {
  const Icon = ICONS[name] ?? Sparkles;
  return <Icon className={className} aria-hidden="true" />;
}
